import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
// import Checkbox from '@material-ui/core/Checkbox';
import Chip from "@material-ui/core/Chip";
import CustomFields from "../customfields/CustomFields";
import { setCustomFields } from "../../redux/actions/customFieldsActions";
import DocumentType from "../DocumentType";
import { FormHelperText } from "@material-ui/core";
import TeamAutosuggest from "../TeamAutosuggest";
const styles = (theme) => ({
  formControl: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    minWidth: 120,
  },
});
export class TemplateConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 0,
      template: { canBeAttached: false, documentTypeId: -1 },
      customFields: [],
      teamNames: [],
      selectedTeam: null,
      nameTouched: false,
      descriptionTouched: false,
      teamsTouched: false,
      docTypes: [],
    };
  }
  removeAnyDocumentTypes = (docTypes) => {
    let clone = [...docTypes];
    for (let i = 0; i < clone.length; i++) {
      if (clone[i].documentTypeID === -3) clone.splice(i, 1);
    }
    this.setState({ docTypes: clone });
  };
  componentDidMount() {
    if (this.props.template) {
      this.setState({ template: this.props.template }, () => {
        if (
          this.state.template.teamIds &&
          this.state.template.teamIds.length > 0
        ) {
          let teamNames = this.props.teams.filter((team) =>
            this.state.template.teamIds.includes(team.teamId)
          );
          this.setState({
            teamNames,
            template: { ...this.state.template, teamNames },
          });
        }
      });
    }
    if (this.props.docTypes) {
      this.removeAnyDocumentTypes(this.props.docTypes);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.docTypes != prevProps.docTypes) {
      this.removeAnyDocumentTypes(this.props.docTypes);
    }
  }
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <DialogTitle style={{ paddingBottom: 0 }}>
          <Trans i18nKey="new_template_confirm_header" />
        </DialogTitle>
        <DialogContent
          style={{ display: "flex", flexDirection: "column", flex: 1 }}
        >
          <TextField
            aria-label="Template name"
            fullWidth
            onBlur={() => this.setState({ nameTouched: true })}
            required
            label={<Trans i18nKey="template_confirm_template_name" />}
            value={this.state.template.name}
            onChange={this.updateName}
            style={{ marginTop: 0 }}
            error={this.state.nameTouched && this.state.template.name === ""}
            helperText={t("global_required")}
          />
          <TextField
            aria-label="Template description"
            fullWidth
            required
            onBlur={() => this.setState({ descriptionTouched: true })}
            label={<Trans i18nKey="global_description" />}
            value={this.state.template.description}
            onChange={this.updateDescription}
            error={
              this.state.descriptionTouched &&
              this.state.template.description === ""
            }
            helperText={t("global_required")}
          />
          <FormControl required className={classes.formControl}>
            <DocumentType
              doctypes={this.props.docTypes}
              docTypeSelected={this.changeDocType}
              documentType={[this.state.template.documentTypeId]}
            />
          </FormControl>
          <FormControl required className={classes.formControl}>
            <div style={{ marginBottom: 10 }}>
              <Typography color="textSecondary">
                <Trans i18nKey="global_team_plural" />
              </Typography>
              <FormHelperText
                style={{ marginBottom: 10 }}
                error={
                  !this.state.template.teamNames ||
                  this.state.template.teamNames.length === 0
                }
              >
                {t("global_required")}
              </FormHelperText>
              <div>
                {this.state.teamNames.length === 0 ? (
                  <Typography
                    color="textSecondary"
                    style={{ textAlign: "center" }}
                  >
                    No teams selected
                  </Typography>
                ) : (
                  <>
                    {this.state.teamNames.map((team) => {
                      return (
                        <Chip
                          key={team}
                          label={team.teamName}
                          className={classes.chip}
                          onDelete={this.handleDelete.bind(this, team)}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            </div>
            <TeamAutosuggest
              clearOnSelect
              onItemSelected={(e) => {
                this.selectTeams(e);
              }}
            />
          </FormControl>
          <FormControl className={classes.formControl}>
            <CustomFields
              template
              customFieldsChange={this.updateCustomFields}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.close} aria-label="Cancel confirm">
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button
            onClick={this.props.saveTemplate.bind(this, this.state.template)}
            disabled={!this.canSubmit()}
          >
            <Trans i18nKey="global_save" />
          </Button>
        </DialogActions>
      </div>
    );
  }

  canSubmit = () => {
    return (
      this.state.template &&
      !!this.state.template.name &&
      !!this.state.template.description &&
      this.state.template.teamNames &&
      this.state.template.teamNames.length > 0
    );
  };

  handleDelete = (e) => {
    this.setState(
      {
        teamNames: this.state.teamNames.filter((team) => {
          return team !== e;
        }),
      },
      () => {
        this.setState({
          template: {
            ...this.state.template,
            teamNames: this.state.teamNames,
          },
        });
      }
    );
  };
  selectTeams = (team) => {
    if (this.state.teamNames.includes(team) === false) {
      this.setState(
        {
          teamNames: [...this.state.teamNames, team],
          teamsTouched: true,
        },
        () => {
          this.setState({
            template: {
              ...this.state.template,
              teamNames: this.state.teamNames,
            },
          });
        }
      );
    }
  };
  updateCustomFields = (array) => {
    this.props.setCustomFields(array);
  };
  updateName = (value) => {
    this.setState({
      template: { ...this.state.template, name: value.target.value },
      nameTouched: true,
    });
  };
  updateDescription = (value, test) => {
    this.setState({
      template: { ...this.state.template, description: value.target.value },
      descriptionTouched: true,
    });
  };
  changeCanBeAttached = (event, value) => {
    this.setState({
      template: { ...this.state.template, canBeAttached: value },
    });
  };
  changeDocType = (value) => {
    if (!value) return;
    this.setState({
      template: {
        ...this.state.template,
        documentTypeId: value.target.value,
      },
    });
  };
}
const mapStateToProps = (state) => ({
  docTypes: state.prefs.documentTypes,
});
const mapDispatchToProps = {
  setCustomFields,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(TemplateConfirm)));
